(function () {
  var STORAGE_KEY = 'am2pm_discount_popup_hidden_until';

  function now() {
    return Date.now();
  }

  function readStore() {
    var value = null;
    try {
      value = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      value = null;
    }
    if (!value) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + STORAGE_KEY + '=([^;]*)'));
      if (match) value = decodeURIComponent(match[1]);
    }
    return value ? parseInt(value, 10) : 0;
  }

  function writeStore(days) {
    var until = now() + days * 24 * 60 * 60 * 1000;
    try {
      window.localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {}
    document.cookie =
      STORAGE_KEY + '=' + until + ';expires=' + new Date(until).toUTCString() + ';path=/;SameSite=Lax';
  }

  function isSuppressed() {
    var until = readStore();
    return !!until && until > now();
  }

  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function discountUrl(code, redirect) {
    var url = rootUrl().replace(/\/$/, '') + '/discount/' + encodeURIComponent(code);
    if (redirect) url += '?redirect=' + encodeURIComponent(redirect);
    return url;
  }

  function currentPath() {
    return window.location.pathname + window.location.search;
  }

  function applyDiscount(code) {
    return fetch(discountUrl(code), {
      method: 'GET',
      credentials: 'same-origin'
    }).catch(function () {});
  }

  function copyCode(code) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(code).catch(function () {
        return legacyCopy(code);
      });
    }
    return Promise.resolve(legacyCopy(code));
  }

  function legacyCopy(code) {
    var area = document.createElement('textarea');
    area.value = code;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    document.body.removeChild(area);
  }

  function DiscountPopup(el) {
    this.el = el;
    this.dialog = el.querySelector('[data-dp-dialog]');
    this.code = el.getAttribute('data-code') || '';
    this.delay = parseFloat(el.getAttribute('data-delay') || '6') * 1000;
    this.days = parseInt(el.getAttribute('data-days') || '7', 10);
    this.designMode = el.getAttribute('data-design-mode') === 'true';
    this.tab = el.getAttribute('data-tab-id') ? document.getElementById(el.getAttribute('data-tab-id')) : null;
    this.tabTimer = null;
    this.timer = null;
    this.feedbackTimer = null;
    this.lastFocus = null;
    this.scrollPosition = 0;
    this.onKeydown = this.handleKeydown.bind(this);
    this.bind();
    this.schedule();
  }

  DiscountPopup.prototype.bind = function () {
    var self = this;

    this.el.querySelectorAll('[data-dp-dismiss]').forEach(function (node) {
      node.addEventListener('click', function (event) {
        event.preventDefault();
        self.dismiss();
      });
    });

    var codeButton = this.el.querySelector('[data-dp-code]');
    if (codeButton) {
      codeButton.addEventListener('click', function (event) {
        event.preventDefault();
        self.redeemInline();
      });
    }

    var cta = this.el.querySelector('[data-dp-redeem]');
    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        self.redeem();
      });
    }

    if (this.tab) {
      this.tab.addEventListener('click', function (event) {
        event.preventDefault();
        self.open();
      });
    }
  };

  DiscountPopup.prototype.showTab = function () {
    var tab = this.tab;
    if (!tab) return;
    window.clearTimeout(this.tabTimer);
    tab.hidden = false;
    void tab.offsetWidth;
    tab.classList.add('is-visible');
  };

  DiscountPopup.prototype.hideTab = function () {
    var tab = this.tab;
    if (!tab || tab.hidden) return;
    tab.classList.remove('is-visible');
    window.clearTimeout(this.tabTimer);
    this.tabTimer = window.setTimeout(function () {
      if (!tab.classList.contains('is-visible')) tab.hidden = true;
    }, 350);
  };

  DiscountPopup.prototype.schedule = function () {
    if (this.designMode) {
      this.open();
      return;
    }
    if (isSuppressed()) {
      this.showTab();
      return;
    }
    this.startTimer();
  };

  DiscountPopup.prototype.startTimer = function () {
    var self = this;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(function () {
      self.open();
    }, this.delay);
  };

  DiscountPopup.prototype.open = function () {
    if (this.el.classList.contains('is-open')) return;
    this.lastFocus = document.activeElement;
    this.scrollPosition = window.scrollY || window.pageYOffset || 0;
    var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.body.style.setProperty('--am2pm-dp-scrollbar-width', scrollbarWidth + 'px');
    this.hideTab();
    this.el.hidden = false;
    document.documentElement.classList.add('am2pm-dp-open');
    document.body.style.setProperty('--am2pm-dp-scroll-offset', '-' + this.scrollPosition + 'px');
    document.body.classList.add('am2pm-dp-open');
    void this.el.offsetWidth;
    this.el.classList.add('is-open');
    document.addEventListener('keydown', this.onKeydown);
    var focusTarget = this.el.querySelector('[data-dp-redeem]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  };

  DiscountPopup.prototype.close = function () {
    var self = this;
    var restoreScroll = this.scrollPosition;
    window.clearTimeout(this.timer);
    document.removeEventListener('keydown', this.onKeydown);
    this.el.classList.remove('is-open');
    document.documentElement.classList.remove('am2pm-dp-open');
    document.body.classList.remove('am2pm-dp-open');
    document.body.style.removeProperty('--am2pm-dp-scroll-offset');
    document.body.style.removeProperty('--am2pm-dp-scrollbar-width');
    window.scrollTo(0, restoreScroll);
    window.setTimeout(function () {
      if (!self.el.classList.contains('is-open')) self.el.hidden = true;
    }, 300);
    this.showTab();
    if (this.tab && !this.tab.hidden) {
      this.tab.focus({ preventScroll: true });
    } else if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      this.lastFocus.focus({ preventScroll: true });
    }
  };

  DiscountPopup.prototype.dismiss = function () {
    if (!this.designMode) writeStore(this.days);
    this.close();
  };

  DiscountPopup.prototype.redeem = function () {
    if (!this.designMode) writeStore(this.days);
    if (!this.code) {
      this.close();
      return;
    }
    window.location.href = discountUrl(this.code, currentPath());
  };

  DiscountPopup.prototype.redeemInline = function () {
    if (!this.code) return;
    if (!this.designMode) writeStore(this.days);
    copyCode(this.code);
    applyDiscount(this.code);
    var feedback = this.el.querySelector('[data-dp-copied]');
    if (!feedback) return;
    feedback.textContent = feedback.getAttribute('data-copied-text') || '';
    feedback.classList.add('is-visible');
    window.clearTimeout(this.feedbackTimer);
    this.feedbackTimer = window.setTimeout(function () {
      feedback.classList.remove('is-visible');
    }, 4000);
  };

  DiscountPopup.prototype.handleKeydown = function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      this.dismiss();
      return;
    }
    if (event.key !== 'Tab' || !this.dialog) return;
    var focusable = this.dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-am2pm-discount-popup]').forEach(function (el) {
      if (el.dataset.dpInit === 'true') return;
      el.dataset.dpInit = 'true';
      new DiscountPopup(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    document.documentElement.classList.remove('am2pm-dp-open');
    document.body.classList.remove('am2pm-dp-open');
    document.body.style.removeProperty('--am2pm-dp-scroll-offset');
    document.body.style.removeProperty('--am2pm-dp-scrollbar-width');
    init(event.target);
  });
})();
